import { useWoStatuses, woStatusLabel, woStatusOf } from "utils/woStatus";

/**
 * <option>s for a WO status <select>, from Settings -> WO Statuses (user,
 * 2026-10-29). `current` keeps a value that is not in the list (an old or
 * deleted status) selectable, so the select still shows what the WO has.
 */
export default function WoStatusOptions({ current }) {
  const statuses = useWoStatuses();
  return (
    <>
      {statuses.map((s) => (
        <option key={s.value} value={s.value}>
          {s.name}
        </option>
      ))}
      {current && statuses.length > 0 && !woStatusOf(statuses, current) && (
        <option value={current}>{current}</option>
      )}
    </>
  );
}

// Read-only status box (customer-role users): the status' name, not its
// stored value.
export function WoStatusReadOnly({ value, className = "form-control" }) {
  const statuses = useWoStatuses();
  return <input className={className} readOnly value={woStatusLabel(statuses, value)} />;
}
